import { Component } from '@angular/core';

@Component({
  selector: 'pcs-modal-body',
  template: '<ng-content></ng-content>'
})
export class ModalBodyComponent {
}
